import React, { useState } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { TextValidator, SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import Button from "@mui/material/Button";
import { CircularProgress } from '@mui/material';
import { getPartnerGuid } from '../../../../../lib/access.es6';
import { eventDateProblem } from '../../../../../lib/claimEventDate.es6';

const SelectPolicy = (props) => {
  if (!props.policies) {
    return
  }
  const classes = useStyle();
  const [policies, setPolicies] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [policy, setPolicy] = useState('');
  const [customerguid, setCustomerguid] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "policies") {
      setPolicies(value)
      setPolicy(value)
      setCustomerguid(value.customer_guid)
    }
    if (name === "eventDate") {
      setEventDate(value)
    }
  }


  // Nothing is claimable on the day the cover started, and nothing is claimable in
  // the future. The engine already refuses both — it rejected a real claim with
  // "Claim event date ... is outside policy coverage period" — but only after the
  // claim had been created, so the file existed and had to be chased. Blocking here
  // is what stops it being logged at all.
  //
  // The field's old `maxNumber:<today>` validator cannot do this: that rule runs
  // parseFloat over the value, so "2026-08-07" collapses to 2026 and it only ever
  // compared years. ISO dates compare correctly as plain strings, which is what the
  // helper does.
  const eventDateError = eventDateProblem({
    eventDate: eventDate,
    policyStartDate: policy ? policy.start_date : undefined,
    blockCommencementDay: getPartnerGuid() === 'omk'
  });

  const handlePolicies = () => {
    // Belt and braces: the button is disabled, but a stray submit must not verify an
    // event date that has already been ruled out.
    if (eventDateError) {
      return
    }
    const payload = {
      "customer_guid": customerguid,
      "policy_guid": policy.guid,
      "event_date": eventDate,
    }
    console.log("select policy ", payload)
    props.handleSelectPolicies(payload);
    // Keep the chosen policy record itself: the claimant step needs its beneficiary /
    // next of kin, which the event quotation does not carry (retest item 21).
    if (props.setAdditionalState) {
      props.setAdditionalState("selected_policy", policy);
    }
    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["event_date"] = eventDate;
    tempClaimInitiation["policy_number"] = policy.policy_number;
    props.setClaimInitiationPayload(tempClaimInitiation);
    // handleReset();
  }
  const filteredPolicies = props.policies.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).filter(policy => policy.active === true)

  return (
    <>
      <ValidatorForm onSubmit={() => handlePolicies()}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={6} sm={6}>
            <SelectValidator
              labelId="select-policy"
              id="select-policy"
              value={policies}
              name='policies'
              type="text"
              label="Select Policy"
              onChange={handleChange}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please select a policy']}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
            >

              {
                filteredPolicies.map((policy, index) => {
                  return (
                    <MenuItem
                      key={index}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }} value={policy}>{policy.policy_number}</MenuItem>
                  )

                })
              }


            </SelectValidator>
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="event-date"
              label="Select Event Date"
              name='eventDate'
              value={eventDate}
              onChange={handleChange}
              style={{ width: "100%" }}
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter an event date']}
              error={!!eventDateError}
              helperText={eventDateError || ''}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sm={12} className={classes.claimBtn}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type='submit'
              disabled={!!eventDateError}
            >
              {props.eventQuoteLoader ? <CircularProgress /> :'Verify event date' }
            </Button>
            {props.eventQuoteSuccess && <p style={{color: 'green'}} >Event found</p>}
            {props.eventQuoteError && <p style={{color: 'red'}} >Event NOT found</p>}
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  )
}

export default SelectPolicy